import {IRange} from "@pg-design/inputs-module";
import {apiPath} from "@pg-mono/rp-api-routes";
import {createTurnstileRtkError} from "@pg-mono/turnstile";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {rpApi} from "../../app/api/rp_api";
import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {createRpLeadPerformanceDebugTrace} from "../../app/performance_debug";
import {appendTurnstileToken} from "../../app/turnstile";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {ConstructionEndDateType} from "../types/ConstructionEndDateType";
import {ForYouFloorChoiceType} from "../types/ForYouFloorChoiceType";

export interface IClientPayload {
    email: string;
    area?: IRange<number>;
    financing_services?: boolean;
    loan_installment?: IRange<number>;
    marketing_consent?: boolean;
    name?: string;
    phone?: string;
    price?: IRange<number> | null;
    regions?: number[];
    rooms?: IRange<number>;
    types?: number[];
    distance?: number;
    additional_areas?: number[];
    comments?: string;
    construction_end_date?: ConstructionEndDateType;
    floors?: ForYouFloorChoiceType[];
    kitchen_type?: number;
    quarters?: number[];
    survey_source: PreferencesSurveySource;
    system_comments?: string;
    no_hm_enable?: boolean;
    explicit_submit?: boolean;
    user_source?: UserSource;
    turnstile_token?: string;
    action?: string;
}

export type IClientUpdatePayload = Partial<IClientPayload>;

interface IUpdateForYouClientArg extends IClientUpdatePayload {
    // When true the Turnstile challenge is skipped. Used by the automatic post-login preferences sync
    // (survey_preferences_action_listener), which runs without a user gesture - triggering an interactive
    // challenge there would surprise the user and could stall the sync.
    skipTurnstile?: boolean;
}

export const forYouClient = rpApi.injectEndpoints({
    endpoints: (build) => ({
        createForYouClient: build.mutation<unknown, IClientPayload>({
            queryFn: async (params, _api, _extraOptions, baseQuery) => {
                const trace = createRpLeadPerformanceDebugTrace("rp_for_you_client_create_api", {
                    action: TurnstileAction.APPLICATION_CREATE,
                    endpoint: "applications.client.create",
                    surveySource: params.survey_source
                });

                try {
                    trace.mark("turnstile_append:start");
                    const payload = await appendTurnstileToken(params, TurnstileAction.APPLICATION_CREATE);
                    trace.mark("turnstile_append:done", {hasTurnstileToken: "turnstile_token" in payload});

                    trace.mark("api_request:start");
                    const result = await baseQuery({
                        url: apiPath.applications.client.create,
                        method: "POST",
                        body: payload
                    });
                    trace.mark("api_request:done", {
                        hasError: Boolean(result.error),
                        status: result.error?.status ?? "success"
                    });

                    if (result.error) {
                        trace.end("query:error", {status: result.error.status});
                        return {error: result.error};
                    }

                    trace.end("query:success");
                    return {data: result.data};
                } catch (_error) {
                    trace.end("query:turnstile_error");
                    return {error: createTurnstileRtkError()};
                }
            },
            invalidatesTags: ["ClientInfo"]
        }),
        updateForYouClient: build.mutation<unknown, IUpdateForYouClientArg>({
            queryFn: async ({skipTurnstile, ...params}, _api, _extraOptions, baseQuery) => {
                const trace = createRpLeadPerformanceDebugTrace("rp_for_you_client_update_api", {
                    action: TurnstileAction.APPLICATION_CREATE,
                    endpoint: "applications.client.update",
                    skipTurnstile: Boolean(skipTurnstile),
                    surveySource: params.survey_source
                });

                try {
                    trace.mark("turnstile_append:start");
                    const payload = skipTurnstile ? params : await appendTurnstileToken(params, TurnstileAction.APPLICATION_CREATE);
                    trace.mark("turnstile_append:done", {
                        hasTurnstileToken: "turnstile_token" in payload,
                        skipped: Boolean(skipTurnstile)
                    });

                    trace.mark("api_request:start");
                    const result = await baseQuery({
                        url: apiPath.applications.client.update,
                        method: "PATCH",
                        body: payload
                    });
                    trace.mark("api_request:done", {
                        hasError: Boolean(result.error),
                        status: result.error?.status ?? "success"
                    });

                    if (result.error) {
                        trace.end("query:error", {status: result.error.status});
                        return {error: result.error};
                    }

                    trace.end("query:success");
                    return {data: result.data};
                } catch (_error) {
                    trace.end("query:turnstile_error");
                    return {error: createTurnstileRtkError()};
                }
            },
            invalidatesTags: ["ClientInfo"]
        })
    })
});

export const {useCreateForYouClientMutation, useUpdateForYouClientMutation} = forYouClient;
import {IRange} from "@pg-design/inputs-module";
import {apiPath} from "@pg-mono/rp-api-routes";
import {createTurnstileRtkError} from "@pg-mono/turnstile";
import {PreferencesSurveySource} from "@pg-rp/common-types";

import {rpApi} from "../../app/api/rp_api";
import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {createRpLeadPerformanceDebugTrace} from "../../app/performance_debug";
import {appendTurnstileToken} from "../../app/turnstile";
import {UserSource} from "../../tracking/tracking_utils/user_source";
import {ConstructionEndDateType} from "../types/ConstructionEndDateType";
import {ForYouFloorChoiceType} from "../types/ForYouFloorChoiceType";

export interface IClientPayload {
    email: string;
    area?: IRange<number>;
    financing_services?: boolean;
    loan_installment?: IRange<number>;
    marketing_consent?: boolean;
    name?: string;
    phone?: string;
    price?: IRange<number> | null;
    regions?: number[];
    rooms?: IRange<number>;
    types?: number[];
    distance?: number;
    additional_areas?: number[];
    comments?: string;
    construction_end_date?: ConstructionEndDateType;
    floors?: ForYouFloorChoiceType[];
    kitchen_type?: number;
    quarters?: number[];
    survey_source: PreferencesSurveySource;
    system_comments?: string;
    no_hm_enable?: boolean;
    explicit_submit?: boolean;
    user_source?: UserSource;
    turnstile_token?: string;
    action?: string;
}

export type IClientUpdatePayload = Partial<IClientPayload>;

interface IUpdateForYouClientArg extends IClientUpdatePayload {
    // When true the Turnstile challenge is skipped. Used by the automatic post-login preferences sync
    // (survey_preferences_action_listener), which runs without a user gesture - triggering an interactive
    // challenge there would surprise the user and could stall the sync.
    skipTurnstile?: boolean;
}

export const forYouClient = rpApi.injectEndpoints({
    endpoints: (build) => ({
        createForYouClient: build.mutation<unknown, IClientPayload>({
            queryFn: async (params, _api, _extraOptions, baseQuery) => {
                const trace = createRpLeadPerformanceDebugTrace("rp_for_you_client_create_api", {
                    action: TurnstileAction.APPLICATION_CREATE,
                    endpoint: "applications.client.create",
                    surveySource: params.survey_source
                });

                try {
                    trace.mark("turnstile_append:start");
                    const payload = await appendTurnstileToken(params, TurnstileAction.APPLICATION_CREATE);
                    trace.mark("turnstile_append:done", {hasTurnstileToken: "turnstile_token" in payload});

                    trace.mark("api_request:start");
                    const result = await baseQuery({
                        url: apiPath.applications.client.create,
                        method: "POST",
                        body: payload
                    });
                    trace.mark("api_request:done", {
                        hasError: Boolean(result.error),
                        status: result.error?.status ?? "success"
                    });

                    if (result.error) {
                        trace.end("query:error", {status: result.error.status});
                        return {error: result.error};
                    }

                    trace.end("query:success");
                    return {data: result.data};
                } catch (_error) {
                    trace.end("query:turnstile_error");
                    return {error: createTurnstileRtkError()};
                }
            },
            invalidatesTags: ["ClientInfo"]
        }),
        updateForYouClient: build.mutation<unknown, IUpdateForYouClientArg>({
            queryFn: async ({skipTurnstile, ...params}, _api, _extraOptions, baseQuery) => {
                const trace = createRpLeadPerformanceDebugTrace("rp_for_you_client_update_api", {
                    action: TurnstileAction.APPLICATION_CREATE,
                    endpoint: "applications.client.update",
                    skipTurnstile: Boolean(skipTurnstile),
                    surveySource: params.survey_source
                });

                try {
                    trace.mark("turnstile_append:start");
                    const payload = skipTurnstile ? params : await appendTurnstileToken(params, TurnstileAction.APPLICATION_CREATE);
                    trace.mark("turnstile_append:done", {
                        hasTurnstileToken: "turnstile_token" in payload,
                        skipped: Boolean(skipTurnstile)
                    });

                    trace.mark("api_request:start");
                    const result = await baseQuery({
                        url: apiPath.applications.client.update,
                        method: "PATCH",
                        body: payload
                    });
                    trace.mark("api_request:done", {
                        hasError: Boolean(result.error),
                        status: result.error?.status ?? "success"
                    });

                    if (result.error) {
                        trace.end("query:error", {status: result.error.status});
                        return {error: result.error};
                    }

                    trace.end("query:success");
                    return {data: result.data};
                } catch (_error) {
                    trace.end("query:turnstile_error");
                    return {error: createTurnstileRtkError()};
                }
            },
            invalidatesTags: ["ClientInfo"]
        })
    })
});

export const {useCreateForYouClientMutation, useUpdateForYouClientMutation} = forYouClient;
